const formatPrice: (price: number) => string = (price: number) => String(Math.floor(price * 100))
  .replace(/(\d{2})$/, ',$1') + '€';

export default formatPrice;